import { ILoginDTO } from '@/dtos';
import { post } from '@/services/apiWrapper';

export const loginAPI = async (body: { email: string; password: string }): Promise<ILoginDTO> => {
  const login = await post<ILoginDTO>('login', body);
  return login;
};
